<template>
  <b-container class="text-center">
    <b-row>
      <b-col>
        <h2 :style="{ color: textColor }" class="text d-flex w-100" :class="titleClasses">
          {{ title }}
        </h2>
        <BrandsBlock :padding="7" :inline-desktop="true" :brands="brands" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BrandsBlock from '@/components/Common/BrandsBlock';

export default {
  components: {
    BrandsBlock
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      textColor: '',
      alignTitle: '',
      brands: [
        {
          src: 'https://cdn.vexels.com/img/licensed-brands/merch-by-amazon2.png',
          alt: 'Merch by amazon'
        },
        { src: 'https://cdn.vexels.com/img/licensed-brands/printful2.png', alt: 'Printful' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/redbubble2.png', alt: 'Redbubble' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/teespring2.png', alt: 'Teespring' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/etsy2.png', alt: 'Etsy' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/zazzle2.png', alt: 'Zazzle' }
      ]
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    title() {
      const landingKey = 'landings.block.pods.title';
      if (this.$te(landingKey)) {
        return this.$t(landingKey);
      } else {
        const exp = this.getExperience;
        const plansKey = `plans.${exp}.tags.licensesTitle`;
        if (this.$te(plansKey)) {
          return this.$t(plansKey);
        } else {
          const lifetimePlansKey = `lifetimePlans.${exp}.tags.licensesTitle`;
          if (this.$te(lifetimePlansKey)) {
            return this.$t(lifetimePlansKey);
          } else {
            return 'Compatible with:';
          }
        }
      }
    },
    titleClasses() {
      return this.alignTitle === 'left'
        ? 'justify-content-start'
        : this.alignTitle === 'right'
        ? 'justify-content-end'
        : 'justify-content-center';
    }
  },
  created() {
    const { primary } = this.slice;
    this.textColor = primary.text_color ? primary.text_color : '';
    this.alignTitle = primary.align_title ? primary.align_title : '';
  }
};
</script>

<style lang="scss" scoped>
.text {
  font-weight: 500;
  font-size: 1.3em;
  color: $strongGray;
}
</style>
